import React from 'react';
import SmallSpinner from "../SmallSpinner";

const LargeSpinner = () => {
    return (
        <div className={'text-center my-5'}>
            <SmallSpinner large/>
        </div>
    );
};

export default LargeSpinner;
